export default "__VITE_ASSET__BZmXlBCY__"